<!-- swipe info -->
<div class="info-container">
    <h3><span class="badge badge-dark-20 badge-pill">Swipe card right and left</span></h3>
</div>
<!-- ./swipe info -->
<!-- app swipe cards -->
<app-swipe-cards [cards]="cards" (choiceMade)="logChoice($event)"></app-swipe-cards>
<!-- ./end app swipe cards -->
<!-- timer -->
<section class="timer-container">
    <h3><span class="badge badge-dark-20 badge-pill">00:{{getFormatedNumber(timeLeft)}}s</span></h3>
</section>
<!-- ./end timer -->
<!-- buy more rounds model -->
<section>
    <div class="modal fade" id="buyroundsModel" data-backdrop="static" tabindex="-1" role="dialog"
        aria-labelledby="buyroundsModelLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="">
                        <img src="assets/icons/like_good.png" alt="like_good" width="84" height="84">
                        <h2 class="text-main font-weight-bold">Very Good</h2>
                    </div>
                    <div class="answer-container">
                        <div class="number">{{correctAnswers || '1'}}</div>
                        <h5 class="font-weight-bold my-2">Correct Answers</h5>
                    </div>
                    <button class="btn btn-danger btn-block btn-lg bg-gradient rounded-pill" data-toggle="modal"
                        data-target="#otpModal" data-dismiss="modal">Buy 3 more rounds with 2 AED</button>
                    <div class="footer">
                        <button class="btn btn-secondary btn-sm mb-2">Home</button>
                        <a href="">Terms & Conditions</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- ./end buy more rounds model -->
<!-- otp model -->
<section>
    <div class="modal fade" id="otpModal" data-backdrop="static" tabindex="-1" role="dialog"
        aria-labelledby="otpModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="">
                        <img src="assets/icons/otp.png" alcorrectAnswerst="otp" width="84" height="84">
                        <h2 class="text-main font-weight-bold">OTP</h2>
                    </div>
                    <div class="otp-container">
                        <label for="otp" class="font-weight-bold">Please enter 4 digit code you received on your mobile
                            number</label>
                        <div class="input-container">
                            <input type="tel" maxlength="1" class="form-control form-control-lg text-center m-2">
                            <input type="tel" maxlength="1" class="form-control form-control-lg text-center m-2">
                            <input type="tel" maxlength="1" class="form-control form-control-lg text-center m-2">
                            <input type="tel" maxlength="1" class="form-control form-control-lg text-center m-2">
                        </div>
                    </div>
                    <div class="mx-2 my-3">
                        <div class="mb-2 text-black-50">Get OTP on your mobile number <span
                                class="text-second">(1:56s)</span></div>
                        <div class="mb-2 text-black-50">Didn't receive SMS? <span class="text-second">RESEND CODE</span>
                        </div>
                    </div>
                    <div class="mx-4">
                        <button class="btn btn-danger btn-block btn-lg bg-gradient rounded-pill" data-toggle="modal"
                            data-target="#successModal" data-dismiss="modal">Confirm the Purchase</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- ./end otp model -->
<!-- success model -->
<section>
    <div class="modal fade" id="successModal" data-backdrop="static" tabindex="-1" role="dialog"
        aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="">
                        <img src="assets/icons/correct_tick.png" alt="correct_tick" width="84" height="84">
                        <h2 class="text-success font-weight-bold">Great</h2>
                    </div>
                    <h5 class="font-weight-bold my-2">You have subscribed for 3 chance daily</h5>
                    <div class="mx-4">
                        <button (click)="loadquestionsCards()"
                            class="btn btn-danger btn-block btn-lg bg-gradient rounded-pill" data-dismiss="modal">
                            Play Now
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>